module.exports = __webpack_public_path__ + "r-v3/img/premium_background.c6a28d7f.png";